// extracted by mini-css-extract-plugin
export default {"root":"ReferralPromoModal__root--LAGOP","text":"ReferralPromoModal__text--2gfUf"};